<template>
  <div class="lstIzin">
    <div class="col-12">
      <div class="list-group">
        <div v-for="(item, index) in listOfizin" :key="index" class="py-1 px-2">
          <a href="#" class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Pengajuan Cuti</h5>
              <!-- <small class="text-muted">{{ item.created_on }}</small> -->
              <button
                class="btn btn-danger"
                @mousedown.prevent="hapus(item.autono)"
              >
                Hapus
              </button>
            </div>
            <p class="mb-1">
              Tanggal Awal Cuti : {{ formatDate(item.tanggal_awal_cuti) }}
            </p>
            <p class="mb-1">
              Tanggal Akhir Cuti : {{ formatDate(item.tanggal_akhir_cuti) }}
            </p>
            <p class="mb-1">Lama Cuti : {{ item.total_cuti_diambil }} hari</p>
            <small class="text-muted" v-if="item.status == 0">Pending</small>
            <small class="text-success" v-else-if="item.status == 1"
              >Disetujui</small
            >
            <small class="text-danger" v-else>Tidak Disetujui</small>
          </a>
        </div>
        <button
          type="button"
          class="btn btn-succes btn-sm"
          :class="{ 'd-none': btnDisabled }"
          @click.prevent="loadMore(page)"
        >
          {{ btnLoadMoreName }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
const Swal = require("sweetalert2");
import moment from "moment";
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + sessionStorage.getItem("key"),
};
export default {
  data() {
    return {
      page: 2,
      id: localStorage.getItem("id"),
      listOfizin: [],
      dataEmpty: true,
      btnDisabled: false,
      btnLoadMoreName: "Muat Lebih Banyak",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    loadMore(pages) {
      try {
        axios
          .post(
            this.UrlApi + "listcuti/pending?page=" + pages,
            {
              id: this.id,
            },
            { headers: headers }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              // this.dataEmpty = res.data.data.length > 0 ? true : false;
              if (res.data.data.length > 0) {
                this.page += 1;
                Array.prototype.push.apply(this.listOfizin, res.data.data);
                // console.log(this.listOfizin);
              } else {
                this.btnLoadMoreName = "Data Sudah Diload Seluruhnya";
                this.btnDisabled = true;
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    hapus(autono) {
      try {
        axios
          .post(
            this.UrlApi + "pengajuan/cuti/hapus",
            {
              id: autono,
            },
            { headers: headers }
          )
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: "Berhasil!",
              text: res.data.data.message,
              showConfirmButton: false,
              timer: 2000,
            });
            window.location.reload();
            // if (res.data.success && res.data.success !== null) {
            //   // this.dataEmpty = res.data.data.length > 0 ? true : false;
            //   if (res.data.data.length > 0) {
            //     this.page += 1;
            //     Array.prototype.push.apply(this.listOfizin, res.data.data);
            //   } else {
            //     this.btnLoadMoreName = "Data Sudah Diload Seluruhnya";
            //     this.btnDisabled = true;
            //   }
            // } else {
            // Swal.fire({
            //   icon: "error",
            //   title: "Gagal!",
            //   text: res.data.message,
            //   showConfirmButton: false,
            //   timer: 1500,
            // });
            // }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    try {
      axios
        .post(
          this.UrlApi + "listcuti/pending?page=",
          {
            id: this.id,
          },
          { headers: headers }
        )
        .then((res) => {
          if (res.data.success && res.data.success !== null) {
            this.dataEmpty = res.data.data.length > 0 ? true : false;
            this.listOfizin = res.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
